/**
 * FY premium cart drawer — title count & shipping refresh (no DOM observers to avoid loops)
 */
(function () {
  var shippingRefreshTimer = null;

  function refreshCartShipping() {
    var cartItems = document.getElementById('cart-items');
    if (cartItems && typeof cartItems.updateShippingNotification === 'function') {
      cartItems.updateShippingNotification('cart-shipping-notification');
    }
  }

  function scheduleShippingRefresh(delay) {
    if (shippingRefreshTimer) {
      clearTimeout(shippingRefreshTimer);
    }
    shippingRefreshTimer = setTimeout(function () {
      shippingRefreshTimer = null;
      refreshCartShipping();
    }, delay || 0);
  }

  function updateDrawerTitle() {
    var titleEl = document.querySelector('[data-fy-cart-item-count]');
    if (!titleEl) return;
    var badge = document.querySelector('[data-fy-cart-count]');
    var count = badge ? parseInt(badge.textContent, 10) : 0;
    if (isNaN(count)) count = 0;
    var template =
      (window.fyCartDrawerStrings && window.fyCartDrawerStrings.titleTemplate) ||
      titleEl.getAttribute('data-template') ||
      'Cart • [count] items';
    titleEl.textContent = template.replace('[count]', String(count));
  }

  function init() {
    updateDrawerTitle();
    refreshCartShipping();

    document.addEventListener('ajaxProduct:added', function () {
      setTimeout(function () {
        updateDrawerTitle();
        scheduleShippingRefresh(0);
      }, 400);
    });

    document.addEventListener('cart:update', function () {
      updateDrawerTitle();
      scheduleShippingRefresh(100);
    });

    var drawer = document.getElementById('drawer-cart');
    if (drawer) {
      new MutationObserver(function () {
        if (drawer.classList.contains('is-open')) {
          updateDrawerTitle();
          scheduleShippingRefresh(0);
          var cartItems = drawer.querySelector('cart-items');
          if (cartItems && typeof cartItems.renderItems === 'function') {
            cartItems.renderItems();
          }
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
